import { get } from 'lodash';
import React, { ChangeEvent } from 'react';
import { LinkRequestType } from '~/types/models/testimonial';
import { getLinkIconUrl } from '../../Testimonials/Components/Respondents/Response/ResponseLabel';
import { Links } from './SearchModal';

export interface ProfileLinkProps {
  placeholder: string;
  linkType: LinkRequestType;
  onChange: (profileKey: string, value: Links) => void;
  linkKey: keyof Links;
  links?: Links;
}

export default function ProfileLink({
  placeholder,
  linkType,
  onChange,
  linkKey,
  links,
}: ProfileLinkProps) {
  getLinkIconUrl(linkType);
  function handleInputChange(e: ChangeEvent<HTMLInputElement>) {
    onChange('social_links', { [e.target.name]: e.target.value });
  }

  return (
    <div className='border border-solid border-neutral px-2 flex rounded items-center mb-[15px] focus-within:border-turquoise'>
      <img src={getLinkIconUrl(linkType)} className='rounded h-[30px]' />
      <input
        defaultValue={get(links, linkKey) as string}
        name={linkKey}
        onChange={handleInputChange}
        className='border-none px-2 py-0 w-full h-[40px] focus:outline-none'
        placeholder={placeholder}
      />
    </div>
  );
}
